export interface ConvertExperienceType {
  key: string;
  locationProperties?: Record<string, unknown>;
  visitorProperties?: Record<string, unknown>;
  updateVisitorProperties?: boolean;
}

export const warrantyDiscountExperience: ConvertExperienceType = {
  key: `warranty-discount-exp-${process.env.NEXT_PUBLIC_ENV_NAME ?? "local"}`,
  locationProperties: {
    slug: "purchase/coverage",
  },
  visitorProperties: {
    isGuestUser: true,
  },
  updateVisitorProperties: true,
};

export const kijijiIcoWithVehiclePhotoUploadExperience: ConvertExperienceType =
  {
    key: `ico-photo-upload-exp-${process.env.NEXT_PUBLIC_ENV_NAME ?? "local"}`,
    locationProperties: {
      slug: "kijiji-ico",
    },
    visitorProperties: {
      isGuestUser: true,
    },
    updateVisitorProperties: true,
  };

export const kijijiIcoSearchVehicleByNameExperience: ConvertExperienceType = {
  key: `ico-search-by-ymm-${process.env.NEXT_PUBLIC_ENV_NAME ?? "local"}`,
  locationProperties: {
    slug: "kijiji-ico",
  },
  visitorProperties: {
    isGuestUser: true,
  },
  updateVisitorProperties: true,
};
